export default "__VITE_ASSET__C9bsvFtE__"